import { useEmbarcacaoAcomodacoes } from "../../../../hooks/use-embarcacao-acomodacoes";
import {
  EMPTY_FIELD_PLACEHOLDER,
  formatDetailCell,
  latestAtualizacao,
} from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  ACOMODACOES_COLUMNS,
  ACOMODACOES_EMPTY_STATE,
  ACOMODACOES_FIELDS,
  ACOMODACOES_ID,
  ACOMODACOES_LOADING_MESSAGE,
  ACOMODACOES_TABLE_MIN_WIDTH,
  ACOMODACOES_TEST_ID,
  ACOMODACOES_TITLE,
} from "./acomodacoes-section.constants";

/**
 * Seção Acomodações do detalhamento da embarcação, somente para consulta: campos gerais e uma linha por tipo de
 * acomodação (AC3). Quantidade e capacidade saem no idioma da tela, sem arredondar; a célula ou o campo sem valor mostra "Campo sem preenchimento" (HU 1734, cenário 03).
 */
export function useAcomodacoesSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, acomodacoes, errorMessage, reload } = useEmbarcacaoAcomodacoes(embarcacaoId);

  return {
    id: ACOMODACOES_ID,
    title: ACOMODACOES_TITLE,
    testId: ACOMODACOES_TEST_ID,
    fieldsTestId: `${ACOMODACOES_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: ACOMODACOES_LOADING_MESSAGE,
    emptyContent: ACOMODACOES_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: acomodacoes
      ? latestAtualizacao([acomodacoes.ultimaAtualizacao, acomodacoes.atualizacaoAcomodacao])
      : undefined,
    fields: buildDetailFields(
      acomodacoes,
      ACOMODACOES_FIELDS,
      ACOMODACOES_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
    // Sem tipos de acomodação não há tabela, só os campos gerais.
    tabela:
      acomodacoes && acomodacoes.acomodacoes.length > 0
        ? {
            title: ACOMODACOES_TITLE,
            testId: `${ACOMODACOES_TEST_ID}-table`,
            minWidth: ACOMODACOES_TABLE_MIN_WIDTH,
            columns: ACOMODACOES_COLUMNS,
            rows: acomodacoes.acomodacoes.map((tipo, index) => ({
              key: index,
              tipo: formatDetailCell(tipo.tipo),
              quantidade: formatDetailCell(tipo.quantidade),
              quantoComporta: formatDetailCell(tipo.quantoComporta),
              comentario: formatDetailCell(tipo.comentario),
            })),
          }
        : null,
  };
}
